import { gql } from '@apollo/client'

export const EXPORT_PACKAGING_QUERY = gql`
  query PackagingPieces(
    $first: Int
    $after: String
    $where: PackagingPiecesGraphQlFilterInput
    $order: [PackagingPiecesGraphQlSortInput!]
  ) {
    packagingPieces(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        state
        sourcedFromRERRoW
        typicalUses
        packagingType
        pieceGroup
        pieceName
        clickUpId
        totalMass
        maximumLoadingCapacity
        length
        width
        height
        numberOfUses
        packagingMaterialLoss
        numberOfComponents
        material
        carbon
        waterUsage
        eutrophication
        comment
        secondaryDataReferenceSourceType
        dataQualityReliabilityScore
        referencesSamplingYear
        referenceDataPublicationYear
        referenceSourcingCountry
        referenceCountryISOCode
        referenceRegionIdentifier
        dataQualityComment
        lastPublishedDate
        researcherName
        researcherEmail
        isVerified
        verificationComments
        verifiedByName
        verifiedByEmail
        verifiedOn
        updated
        lastUpdatedName
        userId
        userEmail
        companyId
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
